<template>
  <div class="version-update mask" v-if="isVersionUpdate || manuallyShown">
    <div class="version-update-box">
      <div class="update-background"></div>
      <p class="update-title">来画动画更新啦~</p>
      <div
        class="updeta-cloase iconfont iconguanbi1"
        @click="close"
      ></div>
      <div class="update-list" ref="updateList" v-if="updetaData">
        <div class="progress-line" ref="progressLine"></div>
        <div
          v-for="(item, index) in updetaData.dataList"
          :key="index"
          class="update-des"
          :id="'update-des' + index"
          ref="updateDes"
        >
          <div class="update-des-item-mark"></div>
          <div class="update-des-date">{{ item.title }}</div>
          <p v-html="item.detail" class="update-des-content"></p>
        </div>
        <div class="update-des-bottom update-des" ref="updateDes">
          <div class="update-des-item-mark"></div>
          <a
            class="update-des-bottomText"
            target="_blank"
            href="https://www.laihua.com/about?id=10"
            >到底啦，更多来画动画日志，请点此查看</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {},
  components: {},
  data() {
    return {
      isVersionUpdate: false,
      updetaData: {},
      versionNo: "",
      manuallyShown: false
    };
  },
  watch: {},
  created() {
    this.$bus.on('openVersionPopup', this.open);
  },
  mounted() {
    this.onInit();
  },
  beforeDestroy () {
    this.$bus.off('openVersionPopup', this.open);
  },
  computed: {},
  updated() {
    $(".update-des").find("strong").css({
      "margin-bottom": "14px",
      display: "block",
    });
    $(".update-des").find("video").css({
      "margin-bottom": "20px",
      "margin-top": "14px",
    });
  },
  methods: {
    open () {
      this.$http.get("/api/updateInfo").then((res) => {
        this.updetaData = res.data.data;
        this.manuallyShown = true;
      });
    },
    close () {
      this.isVersionUpdate = false;
      this.manuallyShown = false;
      this.$bus.emit('openPresentationTip');
    },
    onInit() {
      if (this.$route.userTask) return;
      this.$http.get("/api/updateInfo").then((res) => {
        this.updetaData = res.data.data;
        const versionNos = localStorage.getItem("isVersionUpdate");
        if (res.data.data) {
          if (versionNos != res.data.data.versionNo) {
            localStorage.setItem("isVersionUpdate", res.data.data.versionNo);
            this.isVersionUpdate = true;
          } else {
            this.isVersionUpdate = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 25;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  .updeta-cloase {
    height: 18px;
    width: 18px;
    font-size: 20px;
    border-radius: 50%;
    background: #666666;
    color: #ffffff;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}
.version-update-box {
  position: absolute;
  left: 50%;
  top: 12%;
  margin-left: -325px;
  width: 649px;
  max-height: 70%;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
  text-align: left;
  padding: 30px 0 56px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: Microsoft YaHei;

  .update-title {
    padding: 0 30px;
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    color: #e56a17;
  }
  .update-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 267px;
    background-size: cover;
    background-image: url("/static/img/update-back.png");
  }
  .update-list {
    padding: 0 30px;
    box-sizing: border-box;
    margin-top: 20px;
    min-height: 200px;
    height: 100%;
    overflow-y: scroll;
    position: relative;
    .update-des-bottom {
      padding-bottom: 0 !important;
      .update-des-item-mark {
        bottom: 0 !important;
      }
      .update-des-bottomText {
        position: absolute;
        bottom: -6px;
        margin-left: 13px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #e56a17;
        position: relative;
      }
    }
    .update-des {
      position: relative;
      padding-bottom: 26px;
      border-left: 1px solid rgba($color: #e56a17, $alpha: 0.2);
      & >>> strong {
        display: block !important;
        margin-bottom: 14px !important;
      }
      .update-des-item-mark {
        width: 12px;
        height: 12px;
        background: #e56a17;
        border-radius: 50%;
        position: absolute;
        left: -7px;
        top: 13px;
      }
      .update-des-date {
        padding: 8px 0 20px 13px;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: #e56a17;
      }

      .update-des-content {
        margin-left: 13px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #001515;
      }
    }
  }
}

// 滚动条
/*滚动条样式*/
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba($color: #e56a17, $alpha: 0.4);
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0); //设置背景透明
}
</style>



// WEBPACK FOOTER //
// src/components/popups/versionUpdatePopup.vue